module.exports = "/_next/static/images/Samhita-61026ad79d7830e0a9220933e1f1bed4.jpg";